<template>
  <div id="app">
    <section class="bgImg main" id="header">
      <div
          class="img"
          :style="{
          'background-image': `url(${require('@/assets/images/banner_darker.png')})`,
        }"
      >
        <Header/>
        <div class="header-section">
          <article class="article">
            <div class="textBox small order0 headerBox">
              <h1 class="mainTitle blueTitle">Land at Tutbury Road</h1>
              <p style="margin-bottom: 30px">
                Thank you for providing your views on our proposals at Tutbury Road, Burton on Trent. We have now submitted the hybrid planning application to East Staffordshire Borough Council and the documents are  available to view on the Council’s Planning Register shortly (application reference P/2021/00868).  <br/>Please see below for links to further information:
                <!-- Homes England is developing a concept masterplan for land at Tutbury Road, which is located to the northern edge of Burton-upon-Trent. As part of the
                design development, we are seeking the views of members of the public to inform the planning application. -->
              </p>
              <div class="navbar">
                <a
                    href="Land at Tutbury Road - Update.pdf"
                    target="_blank"
                >Update Following Public Engagement
                </a>
               <a target="_blank"
                    href="http://www.eaststaffsbc.gov.uk/Northgate/PlanningExplorer/Generic/StdDetails.aspx?PT=Planning%20Applications%20On-Line&TYPE=PL/PlanningPK.xml&PARAM0=636887&XSLT=/Northgate/PlanningExplorer/SiteFiles/Skins/EastStaffs/xslt/PL/PLDetails.xslt&FT=Planning%20Application%20Details&PUBLIC=Y&XMLSIDE=/Northgate/PlanningExplorer/SiteFiles/Skins/EastStaffs/Menus/PL.xml&DAURI=PLANNING"
                >Link to Planning Application
                </a
                >
                <a href="#register">Register for updates</a>
                
                <!-- <a href="https://forms.office.com/r/vVJFZPumwk"
                >Complete the Survey
                </a
                > -->
              </div>
            </div>
            <div class="textBox order1"></div>
          </article>
        </div>
      </div>
    </section>
    <section id="about">
      <div class="about-section">
        <article class="article">
          <div class="textBox order1">
            <h1 class="blueTitle">About the Site</h1>
            <p>
              Land at Tutbury Road is allocated in the adopted East
              Staffordshire Local Plan for a 500-home sustainable urban
              extension. Staffordshire County Council secured outline planning
              consent in December 2015 for up to 500 homes, a local centre and
              specialist care housing. A detailed application (called Reserved
              Matters) for Phase 1 of the masterplan was later approved in
              January 2019. These consents have not been implemented.
            </p>
          </div>
          <div class="textBox order0">
            <div
                :style="{
                'background-image': `url(${require('@/assets/images/Homesimage.png')})`,
              }"
                class="textBoxImg"
            ></div>
          </div>
        </article>
      </div>
    </section>
    <section class="noPadding">
      <div class="rowimages">
        <div
            :style="{
            'background-image': `url(${require('@/assets/images/Image_01.jpg')})`,
          }"
            class="imageThird"
        ></div>
        <div
            :style="{
            'background-image': `url(${require('@/assets/images/Image_02.jpg')})`,
          }"
            class="imageThird"
        ></div>
        <div
            :style="{
            'background-image': `url(${require('@/assets/images/Image_03.jpg')})`,
          }"
            class="imageThird"
        ></div>
      </div>
    </section>
    <section id="plans">
      <div class="plans-section">
        <div class="seperateTitle">
          <h1 class="blueTitle">About the Plans</h1>
          <h1></h1>
        </div>

        <article class="article">
          <div class="textBox order0">
            <p>
              Homes England are now developing a revised scheme for the site,
              supported by multi-disciplinary consultancy Atkins. This includes
              preparation of a high-quality and deliverable masterplan to
              accompany a new outline planning application, which will be
              submitted to East Staffordshire Borough Council in Summer 2021.
            </p>
          </div>
          <div class="textBox order1">
            <p>
              The outline planning application will be for a residential-led
              development, alongside a mixed-use local centre and specialist
              accommodation for the elderly, that fully meets the policy
              requirements of the East Staffordshire Borough Local Plan. It will
              establish the key principles for development and set the
              parameters which will guide future detailed applications for
              Reserved Matters.
            </p>
          </div>
        </article>
      </div>
    </section>
    <section class="bgImg articleImg" id="involve">
      <div
          class="img"
          :style="{
          background: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ),url(${require('@/assets/images/wheatfield.jpg')})`,
        }"
      >
        <div class="involved-section">
          <article class="article">
            <div class="textBox lightText order0 fullWidth imgText">
              <h1 class="whiteTitle" style="margin-top: 0">Get Involved</h1>
              <p>
                Local communities will be invited to comment on the emerging
                masterplan before the planning application is submitted.
              </p>
              <p>
                Should you like to receive updates on the project, including
                information about future consultation events, please provide
                your details below.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
    <section id="register">
      <div class="registration-section">
        <Register/>
      </div>
    </section>
    <section>
      <div class="return">
        <hr/>
        <div class="toTopBox">
          <a href="#header">
            <div
                :style="{
                'background-image': `url(${require('@/assets/images/ReturnIcon-SVG.svg')})`,
              }"
                class="returnIcon"
            ></div>
          </a>

          <p>Return to Top</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Register from "@/components/Register.vue";
import Header from "@/components/Header.vue";

export default {
  name: "App",
  components: {
    Register,
    Header,
  },
  data()
  {
    return {};
  },
};
</script>

<style lang="scss">
@import "./assets/main.scss";
</style>
